export default __webpack_public_path__ + "static/b-stack-24a86aaa36d106a1051a316945298df0.png";